export const purchaseOrdersEndpoints = {
  getPurchaseOrderByRequestId: { method: 'get', path: '/by-request/{requestId}' },
  syncPurchaseOrderByRequest: { method: 'post', path: '/by-request/{requestId}/sync' },
  updatePurchaseOrder: { method: 'post', path: '/{purchaseOrderId}/update' },
} as const
